import React from 'react';
import classNames from 'classnames';
import { Icon, Spinner } from 'ui';
import addModifiers from 'utils/add_modifiers';
import IlosUploadButton from './IlosUploadButton';

class IlosScreenRecording extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
    };
    this.launchScreenRecorder = this.launchScreenRecorder.bind(this);
  }

  launchScreenRecorder() {
    this.setState({ loading: true });

    setTimeout(() => this.setState({ loading: false }), 5000);
  }

  render() {
    const {
      token,
      buttonStyles,
      skipRecording,
      disabled,
      errorMessage,
      showUploadButton,
      canGatherDataOnTechnicalIssues,
      renderFeedbackContainer,
      previewing,
      i18n,
      finished,
      givenAnswer,
    } = this.props;
    const loading = (
      <div>
        <Spinner />
        <span className="ml-8">{i18n.screen_recording.launching}</span>
      </div>
    );
    const disabledButtonStyles =
      'VideoResponseQuestion-loadingButton h-td-n NewButton--disabled';
    const showDisabledButton = this.state.loading || !token || disabled;
    const videoResponseStyles = classNames(
      'VideoResponseQuestion--screenRecording',
      {
        'VideoResponseQuestion--disabled':
          previewing || (finished && !givenAnswer),
      },
    );

    return (
      <div className={videoResponseStyles}>
        {showUploadButton && token && !disabled && (
          <IlosUploadButton token={token} />
        )}
        {!showUploadButton && (
          <div>
            <div className="VideoResponseQuestion-instructions">
              <div>
                <span className="fw-b">
                  {i18n.screen_recording.instructions.download.condition}
                </span>
                {i18n.screen_recording.instructions.download.content}
              </div>
              <a
                className={`mt-16 ${
                  showDisabledButton && disabledButtonStyles
                } ${addModifiers('NewButton', ['tallAndWide', 'white'])}`}
                href={`https://app.ilosvideos.com/recorder/download/${token}`}
              >
                {i18n.screen_recording.capitalized_download}
              </a>
            </div>
            <div className="VideoResponseQuestion-instructions mt-16 mb-16">
              <div>
                <span className="fw-b">
                  {i18n.screen_recording.instructions.launch.condition}
                </span>
                {i18n.screen_recording.instructions.launch.content}
              </div>
              <a
                className={`mt-16 ${buttonStyles} ${
                  showDisabledButton && disabledButtonStyles
                }`}
                href={`ilosrecord:record?token=${token}`}
                onClick={this.launchScreenRecorder}
                disabled={!token}
              >
                {this.state.loading
                  ? loading
                  : i18n.screen_recording.launch_ilos}
              </a>
            </div>
          </div>
        )}
        {errorMessage && (
          <div className="ErrorContainer ErrorContainer--brandRed d-f ai-c mb-16">
            <Icon name="warning_sign" className="mr-8" />
            <div>
              {i18n.video_response.error} {errorMessage}.{' '}
              {i18n.video_response.error_follow_up}.
            </div>
          </div>
        )}
        {!canGatherDataOnTechnicalIssues && (
          <div className="Response-skipped">
            <span className="mr-4">
              {showUploadButton
                ? i18n.video_response.cannot_record
                : i18n.screen_recording.not_working}
            </span>
            <button
              type="button"
              className={`pl-0 VideoResponseQuestion-transparentButton  ${addModifiers(
                'NewButton',
                ['flat'],
              )}`}
              onClick={skipRecording}
              disabled={disabled}
            >
              {i18n.video_response.skip_action}
            </button>
          </div>
        )}
        {!previewing &&
          canGatherDataOnTechnicalIssues &&
          renderFeedbackContainer()}
      </div>
    );
  }
}

export default IlosScreenRecording;
